export * from './TabbedPage';
export * from './TabbedPage.config';
